import { useEffect, useState } from "react"

const useIsInView = (ref) => {

    const [isIntersecting, setIntersecting] = useState(false)
  
    const observer = new IntersectionObserver(
        ([entry]) => setIntersecting(entry?.isIntersecting)
    )
  
    useEffect(() => {
        if (ref?.current) {
            observer?.observe(ref?.current)
        }

      return () => { observer.disconnect() }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [observer])
  
    return isIntersecting
}

export default useIsInView;
